const PhilosophySection = () => {
  return (
    <section className="philosophy">
      <div className="wrap manifesto reveal">
        <div className="kicker">06 — Philosophy</div>
        <h2>
          We design spaces that <span className="accent">feel inevitable.</span>
        </h2>
        <p>
          Every detail becomes part of the daily ritual. Every proportion has a reason. Every material carries the character of the place.
        </p>
      </div>
    </section>
  );
};

export default PhilosophySection;
